import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes, css } from 'styled-components';
import { getYear, getMonth, addMonths, subMonths, format } from 'date-fns';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function getPrimaryColor(props) {
  return props.primaryColor;
}
function getSecondaryColor(props) {
  return props.secondaryColor;
}
function getHoverColor(props) {
  return props.hoverColor;
}
function getStyleProps(_ref) {
  var primaryColor = _ref.primaryColor,
      secondaryColor = _ref.secondaryColor,
      hoverColor = _ref.hoverColor;
  return {
    hoverColor: hoverColor,
    primaryColor: primaryColor,
    secondaryColor: secondaryColor
  };
}

var _templateObject$5, _templateObject2$2;
var fadeIn = keyframes(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  from {\n    transform: scaleY(0.95);\n    opacity: 0;\n  }\n\n  to {\n    transform: scaleY(1);\n    opacity: 1;\n  }\n"])));
var TooltipContainer = styled.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  margin-top: 8px;\n  transform-origin: top center;\n  animation: ", " .2s;\n  position: absolute;\n  box-shadow: 0 1px 3px #d3d3d380, 0 1px 3px #d3d3d380;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  z-index: 10;\n"])), fadeIn, getPrimaryColor);

var _templateObject$4, _templateObject2$1, _templateObject3$1;
var Month = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  ", "\n\n  &:focus {\n    outline: none;\n  }\n\n  ", ";\n\n  padding: 12px 0;\n  transition: background-color .1s, color .1s;\n  font-size: 14px;\n  background-color: ", ";\n  color: ", ";\n  height: 42px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 0 0 33.33%;\n\n  border-bottom-right-radius: ", ";\n  border-bottom-left-radius: ", ";\n"])), function (props) {
  return !props.selected && css(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n      cursor: pointer;\n\n      &:hover {\n        background-color: ", ";\n      }\n    "])), getHoverColor);
}, function (props) {
  return props.selected && css(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n    border: 1px solid #d3d3d37a;\n  "])));
}, function (props) {
  return props.selected ? getPrimaryColor(props) : getSecondaryColor(props);
}, function (props) {
  return props.selected ? getSecondaryColor(props) : getPrimaryColor(props);
}, function (props) {
  return props.index === 11 && '4px';
}, function (props) {
  return props.index === 9 && '4px';
});

var _templateObject$3;
var SVG$1 = styled.svg(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  fill: ", ";\n"])), getSecondaryColor);
var ArrowRight = (function (props) {
  return /*#__PURE__*/React.createElement(SVG$1, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.25h24v24H0z",
    fill: "none"
  }));
});

var _templateObject$2;
var SVG = styled.svg(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  fill: white;\n  fill: ", ";\n"])), getSecondaryColor);
var ArrowLeft = (function (props) {
  return /*#__PURE__*/React.createElement(SVG, _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h24v24H0z",
    fill: "none"
  }));
});

var _templateObject$1;
var Header = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  padding: 16px 8px;\n  font-weight: bold;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: ", ";\n  color: ", ";\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n"])), getPrimaryColor, getSecondaryColor);

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var Year = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  user-select: none;\n"])));
var Container = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  * {\n    box-sizing: border-box;\n  }\n\n  &:focus {\n    outline: none;\n  }\n"])));
var MonthContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 4px;\n  width: 300px;\n  display: flex;\n  flex-wrap: wrap;\n"])), getSecondaryColor);
var Divider = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  height: 8px;\n  background-color: ", ";\n  width: 100%;\n"])), getSecondaryColor);
var currentDate = new Date();
var currentYear = getYear(currentDate);

var MonthPicker = /*#__PURE__*/function (_React$Component) {
  _inherits(MonthPicker, _React$Component);

  var _super = _createSuper(MonthPicker);

  function MonthPicker(props) {
    var _this;

    _classCallCheck(this, MonthPicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (event) {
      var element = event.target;

      if (_this.wrapperRef && !_this.wrapperRef.contains(element)) {
        _this.close(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMonthChange", function (month) {
      return function (event) {
        event.persist();
        var date = new Date(_this.state.year, month);

        _this.changeValue(date, event);

        _this.close(event);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleTriggerClick", function (event) {
      event.persist();
      var _this$props = _this.props,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur;
      var open = _this.state.open;

      _this.toggleOpen();

      if (!open && onFocus) onFocus();
      if (open && onBlur) onBlur();
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      var _this$state = _this.state,
          open = _this$state.open,
          year = _this$state.year;
      var month = _this.props.month;
      if (!open) return;
      var currentDate = new Date(year, month - 1);

      switch (event.key) {
        case 'ArrowLeft':
          {
            event.preventDefault();
            var nextDate = subMonths(currentDate, 1);
            return _this.changeValue(nextDate, event);
          }

        case 'ArrowRight':
          {
            event.preventDefault();

            var _nextDate = addMonths(currentDate, 1);

            return _this.changeValue(_nextDate, event);
          }

        case 'ArrowUp':
          {
            event.preventDefault();

            var _nextDate2 = subMonths(currentDate, 3);

            return _this.changeValue(_nextDate2, event);
          }

        case 'ArrowDown':
          {
            event.preventDefault();

            var _nextDate3 = addMonths(currentDate, 3);

            return _this.changeValue(_nextDate3, event);
          }

        case 'Enter':
          {
            _this.close();
          }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "nextYear", function () {
      var _this$props2 = _this.props,
          allowedYears = _this$props2.allowedYears;
          _this$props2.month;
      var year = _this.state.year;

      if (Array.isArray(allowedYears)) {
        var sortedYears = allowedYears.sort(function (a, b) {
          return a - b;
        });
        var currentIndex = sortedYears.indexOf(year);

        if (currentIndex < sortedYears.length - 1) {
          var _nextYear = sortedYears[currentIndex + 1];

          _this.setState({
            year: _nextYear
          });
        }
      }

      var nextYear = year + 1;

      if (_this.isAllowedYear(nextYear)) {
        _this.setState({
          year: nextYear
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "previousYear", function () {
      var _this$props3 = _this.props,
          allowedYears = _this$props3.allowedYears;
          _this$props3.month;
      var year = _this.state.year;

      if (Array.isArray(allowedYears)) {
        var sortedYears = allowedYears.sort(function (a, b) {
          return a - b;
        });
        var currentIndex = sortedYears.indexOf(year);

        if (currentIndex > 0) {
          var _previousYear = sortedYears[currentIndex - 1];

          _this.setState({
            year: _previousYear
          });
        }
      }

      var previousYear = year - 1;

      if (_this.isAllowedYear(previousYear)) {
        _this.setState({
          year: previousYear
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleOpen", function () {
      _this.setState(function (_ref) {
        var open = _ref.open;
        return {
          open: !open
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "close", function (event) {
      var onBlur = _this.props.onBlur;
      if (!_this.state.open) return;

      _this.setState({
        open: false
      });

      if (onBlur) onBlur();
    });

    _defineProperty(_assertThisInitialized(_this), "setWrapperRef", function (node) {
      _this.wrapperRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "changeValue", function (date, event) {
      var _this$props4 = _this.props,
          onChange = _this$props4.onChange,
          dateFormat = _this$props4.format;
      var formattedDate = dateFormat ? format(date, dateFormat) : {
        month: getMonth(date) + 1,
        year: getYear(date)
      };
      if (onChange) onChange(formattedDate, event);
    });

    _defineProperty(_assertThisInitialized(_this), "isAllowedYear", function (year) {
      var allowedYears = _this.props.allowedYears;
      if (!allowedYears) return true;

      if (Array.isArray(allowedYears)) {
        return allowedYears.indexOf(year) >= 0;
      }

      var before = allowedYears.before,
          after = allowedYears.after;

      if (before && after) {
        return year < before && year > after;
      }

      if (before) return year < before;
      if (after) return year > after;
      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "renderMonths", function () {
      var _this$props5 = _this.props,
          month = _this$props5.month,
          selectedYear = _this$props5.year,
          locale = _this$props5.locale;
      var year = _this.state.year;
      var selectedMonth = month - 1;
      var monthNameFormatter = Intl.DateTimeFormat(locale, {
        month: 'short'
      });
      var months = [];

      for (var index = 0; index < 12; index++) {
        var monthName = monthNameFormatter.format(new Date(year, index, 1));
        var isSelectedMonth = selectedMonth !== undefined && index === selectedMonth && year === selectedYear;
        months.push( /*#__PURE__*/React.createElement(Month, _extends({
          selected: isSelectedMonth,
          key: monthName,
          onClick: _this.handleMonthChange(index),
          index: index
        }, getStyleProps(_this.props)), monthName));
      }

      return months;
    });

    _this.state = {
      year: props.year,
      open: false
    };
    return _this;
  }

  _createClass(MonthPicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    } // Event handlers

  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          open = _this$state2.open,
          year = _this$state2.year;
      var _this$props6 = this.props,
          className = _this$props6.className,
          dialogClassName = _this$props6.dialogClassName;
          _this$props6.children;
      var styleProps = getStyleProps(this.props);
      return /*#__PURE__*/React.createElement(Container, {
        className: className,
        tabIndex: -1,
        ref: this.setWrapperRef,
        onKeyDown: this.handleKeyDown
      }, /*#__PURE__*/React.createElement("div", {
        onClick: this.handleTriggerClick
      }, this.props.children), open && /*#__PURE__*/React.createElement(TooltipContainer, _extends({
        className: dialogClassName
      }, styleProps), /*#__PURE__*/React.createElement(Header, styleProps, /*#__PURE__*/React.createElement(ArrowLeft, _extends({
        onClick: this.previousYear
      }, styleProps)), /*#__PURE__*/React.createElement(Year, null, year), /*#__PURE__*/React.createElement(ArrowRight, _extends({
        onClick: this.nextYear
      }, styleProps))), /*#__PURE__*/React.createElement(Divider, styleProps), /*#__PURE__*/React.createElement(MonthContainer, styleProps, this.renderMonths())));
    }
  }]);

  return MonthPicker;
}(React.Component);

_defineProperty(MonthPicker, "defaultProps", {
  hoverColor: '#d3d3d330',
  primaryColor: '#27718c',
  secondaryColor: 'white',
  locale: 'de',
  month: getMonth(currentDate),
  year: currentYear
});

_defineProperty(MonthPicker, "propTypes", {
  allowedYears: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.shape({
    before: PropTypes.number,
    after: PropTypes.number
  })]),
  primaryColor: PropTypes.string.isRequired,
  secondaryColor: PropTypes.string.isRequired,
  hoverColor: PropTypes.string.isRequired,
  month: PropTypes.number.isRequired,
  year: PropTypes.number.isRequired,
  format: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  className: PropTypes.string,
  dialogClassName: PropTypes.string
});

export { MonthPicker as default };
